import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const logoutforSpecificErrorCodes = (err) => {
  if (err && err?.response?.status && err?.response?.status === 401) {
    return true;
  } else if (err & err?.response?.status && err?.response?.status === 503) {
    return true;
  } else if (err & err?.response?.status && err?.response?.status === 500) {
    toast.error(
      "Connection has failed. Please check your internet connection."
    );
    return false;
  }
};

export default logoutforSpecificErrorCodes;
